import 'bootstrap';
import { AddressFieldEditor } from './addressFieldEditor';
import { AuthorisationFieldEditor } from './authorisationFieldEditor';
import { DataVisibleWhen } from './visibleWhen';
//import { AppModal } from './appModals';
import { CreditCardField } from './creditCardFieldEditor';
import { Z } from './query';
import { AppModal } from './appModals';
import { HCaptchaHandler } from './captcha';
import { CrossSiteFormsManager } from './crossSiteFormsManager';
import { ContextMenuEvent } from './contextMenuControl';
import { CapGallery } from './galleryView';

export class LEDSignsWebsite {
    static instance: LEDSignsWebsite;
    resizeObserver: any;

    constructor() {
        LEDSignsWebsite.instance = this;
        window['Web'] = this;
        window['LEDDB'] = this;
        window['LED'] = this;

        this.initGui();

        console.log(`LED-Signs website initialised`);
    }

    initGui() {
        if (window['ResizeObserver']) {
            this.resizeObserver = new window['ResizeObserver'](elements => {
                document.dispatchEvent(new Event('resize'));
            });
            this.resizeObserver.observe(document.body);
        }

        document.addEventListener('update-gui', ev => this.updateGui());

        this.updateGui();

        Z.forEach<HTMLTextAreaElement>('input.focus-on-load, textarea.focus-on-load, select.focus-on-load', el => {
            el.focus();

            if (el.select)
                el.select();
        });
    }

    updateGui() {
        AddressFieldEditor.init();
        AuthorisationFieldEditor.init();
        CreditCardField.init();
        DataVisibleWhen.init();
        AppModal.init();
        new CrossSiteFormsManager();

        CapGallery.init();

        this.initContextMenus();

        Z.init('[data-confirm][data-after-confirm]', 'confirmation-action-button', el => {
            el.addEventListener('click', ev => {
                Z.confirm({
                    text: el.dataset.confirm,
                    prompt: el.dataset.promptText || null,
                    confirmText: el.dataset.confirmButtonText || null,
                    dismissText: el.dataset.dismissButtonText || null,
                    icon: el.dataset.confirmIcon || null,
                    lock: el.dataset.confirmationRequired === 'true',
                    class: el.dataset.confirmModalClass || null,

                    onConfirm(ev) {
                        let then = el.dataset.afterConfirm;
                        if (then) {
                            if (then.startsWith('/')) {
                                Z.go(el, then);
                            } else if (then.toLowerCase().startsWith('get:')) {
                                Z.get(el, then.substring('get:'.length));
                            } else if (then.startsWith('#') || then.startsWith('.') || then.startsWith('[') || then.startsWith(':')) {
                                Z.forFirst(then, el2 => el2.click());
                            } else if (then.startsWith('js:')) {
                                eval(then.substring('js:'.length));
                            }
                        }
                    },
                })
            });
        });

        Z.init('[data-submit]', 'submit-form-trigger', btn => {
            btn.addEventListener('click', ev => {
                let form: HTMLFormElement;
                if (btn.dataset.submit === 'this') {
                    form = Z.getParent<HTMLFormElement>(btn, 'form');
                } else {
                    form = Z.one<HTMLFormElement>(btn.dataset.submit);
                }

                if (!form) throw new DOMException(`Form with selector '${btn.dataset.submit}' not found`);

                Z.submitFormAsync(btn, form);
            });
        });

        Z.init<HTMLFormElement>('form#verify-captcha', 'captcha-verification-form', form => {
            new HCaptchaHandler(form, callback => {
                Z.spinUp();
                location.href = form.dataset.then;
            });
        });

        Z.init('[data-go]', 'href-button', el => {
            el.addEventListener('click', ev => {
                Z.spinUp(el);
                let href = el.dataset.go;
                location.href = href;
            });
        });

        Z.init<HTMLAnchorElement>('.nav-menu-v a', 'href-button', el => {
            el.addEventListener('click', ev => {
                if (!el.href.startsWith('#')) {
                    Z.spinUp(el);
                    let href = el.href;
                    location.href = href;
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            });
        });

        Z.init<HTMLAnchorElement>('aside.sidebar a', 'href-button', el => {
            el.addEventListener('click', ev => {
                if (!el.href.startsWith('#')) {
                    Z.spinUp(el);
                    let href = el.href;
                    location.href = href;
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            });
        });

        Z.init('[data-submit-form]', 'submit-form-trigger', el => {
            el.addEventListener('click', ev => {
                let selector = el.dataset.submitForm;
                let form: HTMLFormElement = selector === 'modal' ? Z.oneFrom(Z.getParent(el, '.modal'), 'form') : Z.one(selector);

                if (form) {
                    Z.submitFormAsync(el, form);
                }
            });
        });
        Z.init('[data-reset-form]', 'reset-form-trigger', el => {
            el.addEventListener('click', ev => {
                let selector = el.dataset.resetForm;
                let form: HTMLFormElement = selector === 'modal' ? Z.oneFrom(Z.getParent(el, '.modal'), 'form') : Z.one(selector);

                if (form) {
                    form.reset();
                }
            });
        });

        Z.init<HTMLInputElement>('input[data-intercept-newline]', 'intercept-newline', el => {
            el.addEventListener('keydown', ev => {
                //console.log('keydown', ev);
                if (ev.key == 'Enter') {
                    let thenIntercept = el.dataset.interceptNewline;
                    console.log(`Intercept [${thenIntercept}]`);
                    Z.forEach(thenIntercept, next => {
                        console.log(`=> `, next);
                        if (next.matches('button, a')) {
                            next.click();
                        } else if (next.matches('input, textarea')) {
                            next.focus();
                            (<HTMLInputElement>next).select();
                        }
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                return true;
            });
        });

        Z.init<HTMLInputElement>('input[type="tel"]', 'tel-input', el => {
            el.addEventListener('input', ev => {
                let stripped = '';
                let allowed = '0123456789 +()';
                for (let i = 0; i < el.value.length; i++) {
                    if (allowed.indexOf(el.value[i]) != -1)
                        stripped += el.value[i];
                }
                if (stripped != el.value)
                    el.value = stripped;
            });
        });

        Z.init<HTMLInputElement>('input[type="email"]', 'email-input', el => {
            el.addEventListener('input', ev => {
                //let pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                //if (el.validity.
            });
        });
    }

    cancelNextContextMenu: boolean;
    initialisedGlobalMouseDown: boolean = false;
    initContextMenus() {
        if (!this.initialisedGlobalMouseDown) {
            this.initialisedGlobalMouseDown = true;

            window.addEventListener('mousedown', ev => {
                //R.logIf(this.deepLog, 'mousedown');
                let clicked = ev.target as HTMLElement;

                let allActivePopups = Z.select('.gui-popup.active');
                let doClosePopup = false;
                let ignoreClosePopup = false;

                let inDropdownMenu = Z.getParent(clicked, '.dropdown-menu');
                if (inDropdownMenu) return;

                allActivePopups.forEach(gui => {
                    let attachment = gui.dataset.attachTo;

                    if (attachment) {
                        if (clicked.matches(attachment))
                            return;

                        let attachDom = Z.first(attachment);

                        if (attachDom) {
                            if (attachDom.contains(clicked))
                                return;

                            if (clicked.contains(attachDom))
                                return;
                        }
                    }

                    if (Z.outOfBounds(gui, ev.clientX, ev.clientY)) {
                        doClosePopup = true;
                    } else {
                        ignoreClosePopup = true;
                    }
                });

                let allActiveDropdowns = Z.select('.dropdown-menu.show');
                allActiveDropdowns.forEach(gui => {
                    if (Z.outOfBounds(gui, ev.clientX, ev.clientY)) {
                        //R.logIf(this.deepLog, `dropdown is out of bounds`, gui, ev);
                        doClosePopup = true;
                    } else {
                        ignoreClosePopup = true;
                    }
                });

                if (doClosePopup && !ignoreClosePopup) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    allActivePopups.forEach(gui => gui.classList.remove('active'));
                    //return;
                }

                document.querySelectorAll('.context-menu.active')
                    .forEach((el: HTMLElement) => {
                        if (el.contains(clicked)) {
                            //R.logIf(this.deepLog, `not dismissing active context menu because the context menu contains the clicked element`);
                            //alert(`not dismissing active context menu because the context menu contains the clicked element`);
                            return;
                        }

                        if (clicked.contains(el)) {
                            //R.logIf(this.deepLog, `not dismissing active context menu because the context menu contains the clicked element`);
                            //alert(`not dismissing active context menu because the context menu contains the clicked element`);
                            //return;
                        }
                        if (Z.outOfBounds(el, ev.clientX, ev.clientY)) {
                            el.classList.remove('active');
                            return;
                        }

                        let isSource = false;
                        Z.forEach(`[data-context-menu="#${el.id}"]`, dcm => {
                            if (dcm.contains(clicked))
                                isSource = true;
                        });

                        if (isSource)
                            return;

                        el.classList.remove('active');
                    });
            });
        }

        Z.init(`[data-context-menu]`, 'context-menu-initialised', element => {

            element.addEventListener('contextmenu', ev => {
                if (this.cancelNextContextMenu) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    this.cancelNextContextMenu = false;
                    return;
                }

                let contextMenu = document.querySelector(element.dataset.contextMenu) as HTMLElement;
                let isSubMenu = element.parentElement.classList.contains('context-menu');
                let overrideX, overrideY;

                if (isSubMenu) {
                    overrideX = parseInt(element.parentElement.style.left.replace('px', ''));
                    overrideY = parseInt(element.parentElement.style.top.replace('px', ''));
                }

                Z.forEach('.context-menu.active', cm => {
                    cm.classList.remove('active');
                });

                if (contextMenu) {
                    contextMenu.querySelectorAll('[data-action]')
                        .forEach((actionItem: HTMLElement) => {
                            Z.init(actionItem, 'context-menu-action', actionItem => {
                                let action = actionItem.dataset.action;
                                actionItem.addEventListener('click', ev => {
                                    let event = new ContextMenuEvent(`context-menu:${action}`, Z.getData(contextMenu, 'context-menu-source') as HTMLElement, contextMenu, actionItem, ev as MouseEvent);
                                    contextMenu.dispatchEvent(event);
                                });
                            });
                        });

                    Z.setData(contextMenu, 'context-menu-source', element);
                    contextMenu.classList.add('active');
                    contextMenu.dispatchEvent(new ContextMenuEvent('context-menu-shown', Z.getData(contextMenu, 'context-menu-source') as HTMLElement, contextMenu, null, ev as MouseEvent));

                    let x = overrideX === undefined ? ev.clientX : overrideX;
                    let y = overrideY === undefined ? ev.clientY : overrideY;
                    let w = contextMenu.getBoundingClientRect().width;
                    let h = contextMenu.getBoundingClientRect().height;
                    if (x < 0) x = 0;
                    if (y < 0) y = 0;
                    if (x + w >= window.innerWidth) x = window.innerWidth - w;
                    if (y + h >= window.innerHeight) y = window.innerHeight - h;

                    contextMenu.style.left = x + 'px';
                    contextMenu.style.top = y + 'px';
                }

                ev.preventDefault();
                ev.stopPropagation();
                return false;
            });
        });

        Z.init('.context-menu .btn-menu-item', 'context-menu-item', el => {
            el.addEventListener('click', ev => {
                Z.forEach('.context-menu.active', cm => {
                    cm.classList.remove('active');
                });
            });
        });

        Z.init('[data-function]', 'inline-function-handlers', element => {
            element.addEventListener('click', ev => {
                let funcName = element.dataset.function;
                if (window[funcName] && typeof (window[funcName]) === 'function') {
                    let contextMenu = element.parentElement as HTMLElement;
                    if (contextMenu) {
                        let source = Z.getData(contextMenu)['context-menu-source'];
                        (<any>window[funcName])(source, element, ev);
                    }
                }
            });
        });
    }
}

if (document.readyState === 'complete') {
    new LEDSignsWebsite();
}
else {
    document.addEventListener('readystatechange', ev => {
        if (document.readyState == 'interactive') {
        }

        if (document.readyState === 'complete') {
            new LEDSignsWebsite();
        }
    });
}